import classNames from 'classnames';
import React, { useState, useRef } from 'react';
import { Tooltip } from 'antd-v5';
import { getIsPadWidth } from '@elem/utils/devices';
import EfImg from '../ef-img';
import EfLink from '../ef-link';
import './index.scss';

interface dataLayerType {
    event?: string;
    event_name?: 'buy' | string;
    product_name?: string;
    position?: string;
    [key: string]: any;
}

interface EfShopCardACircleItemsProps {
    /**
     * 类型,用于区分 点击后的值
     */
    type: string;

    /**
     * toolTip 文案
     */
    toolTipText: string;
}
interface EfShopCardAProps {
    /**
     * 位置
     */
    position?: 'default' | 'imgL';
    /**
     * 图片链接
     */
    pc: string;
    /**
     * 圆色图标群
     */
    circleItems: EfShopCardACircleItemsProps[];
    /**
     * 点击圆点时的回调
     * @param item
     * @returns
     */
    callback?: (item: EfShopCardACircleItemsProps) => void;
    /**
     * label
     */
    label?: string;
    /**
     * title
     */
    title?: string;
    /**
     * desc
     */
    desc?: string;

    /**
     * desc2
     */
    desc2?: string;

    /**
     * 更多--链接
     */
    moreLink?: string;

    /**
     * 更多--文案
     */
    moreText?: string;

    /**
     * 样式名
     */
    className?: string;
    /**
     * 外部传递埋点
     */
    dataLayer?: dataLayerType | dataLayerType[] | null;
}

/**
 * 维护:谢保林
 *
 * 购买卡片
 */
const EfShopCardA: React.FC<EfShopCardAProps> = ({
    position,
    circleItems,
    callback,
    pc,
    label,
    title,
    desc,
    desc2,
    moreLink,
    moreText,
    className,
    dataLayer,
}) => {
    const prefixCls = `ef-shop-card-a`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${position}`]: position,
    });

    const circleItems2 = circleItems || [];
    const [activeIndex, setActiveIndex] = useState(0);
    const [hoverIndex, setHoverIndex] = useState(0);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    let timer: any = useRef<any>(null);
    const isMobile = getIsPadWidth(); //是否是移动端

    // 点击切换
    const clickHandle = (item: EfShopCardACircleItemsProps, index: number) => {
        setActiveIndex(index);
        callback && callback(item);
    };

    const handleTooltipVisibleChange = (visible: boolean, index: number) => {
        setTooltipVisible(visible);
        setHoverIndex(index);
        handleClearTimer();
        if (!isMobile) {
            return;
        }
        if (!!visible) {
            timer = setTimeout(() => {
                setTooltipVisible(false);
            }, 2000);
        }
        if (!visible && timer) {
            handleClearTimer();
        }
    };

    const handleClearTimer = () => {
        timer && clearTimeout(timer);
        timer = null;
    };

    return (
        <div className={classes}>
            <div className={`${prefixCls}-img`}>
                <EfImg pc={pc} />
            </div>
            <div className={`${prefixCls}-msg`}>
                {label && <div className={`${prefixCls}-label`}>{label}</div>}
                {title && <div className={`${prefixCls}-title`}>{title}</div>}
                {!!circleItems2.length && (
                    <div className={`${prefixCls}-circle`}>
                        {circleItems2.map((item: EfShopCardACircleItemsProps, index: number) => {
                            return (
                                <Tooltip
                                    open={hoverIndex === index && tooltipVisible}
                                    key={index}
                                    title={item?.toolTipText || ''}
                                    onOpenChange={(visible) => handleTooltipVisibleChange(visible, index)}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                >
                                    <div
                                        className={`${prefixCls}-circle-item${activeIndex === index ? ` ${prefixCls}-circle-item-active` : ''}`}
                                        onClick={() => {
                                            clickHandle(item, index);
                                        }}
                                    ></div>
                                </Tooltip>
                            );
                        })}
                    </div>
                )}
                {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                {desc2 && <div className={`${prefixCls}-desc2`}>{desc2}</div>}
                <div className={`${prefixCls}-btn-box`}>
                    {moreLink && moreText && (
                        <>
                            <EfLink
                                href={moreLink}
                                className={`${prefixCls}-btn`}
                                dataLayer={
                                    dataLayer || {
                                        event: 'uaEvent',
                                        event_name: 'select_product',
                                        button_name: moreText,
                                        product_name: title,
                                        list_name: 'Product Preview',
                                    }
                                }
                            >
                                {moreText}
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                    <path
                                        d="M5.27796 2.22548L9.31934 6.26685L5.27797 10.3082"
                                        stroke="currentColor"
                                        strokeWidth="1.06086"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </EfLink>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EfShopCardA;
